export const socialPartners = [
  {
    id: 'meta_feed',
    name: 'Meta Feed Ads',
    minBudget: 15000,
    maxBudget: 100000,
    impressionRate: 40, // impressions per dollar
    reachRate: 34, // reach per dollar
    baseEfficiency: 85,
    isDeal: true
  },
  {
    id: 'meta_stories',
    name: 'Meta Stories',
    minBudget: 10000,
    maxBudget: 75000,
    impressionRate: 35,
    reachRate: 30,
    baseEfficiency: 82
  },
  {
    id: 'instagram_reels',
    name: 'Instagram Reels',
    minBudget: 20000,
    maxBudget: 150000,
    impressionRate: 45,
    reachRate: 38,
    baseEfficiency: 88
  },
  {
    id: 'tiktok_feed',
    name: 'TikTok For Business',
    minBudget: 25000,
    maxBudget: 200000,
    impressionRate: 50,
    reachRate: 42,
    baseEfficiency: 90
  },
  {
    id: 'snap_discover',
    name: 'Snapchat Discover',
    minBudget: 15000,
    maxBudget: 100000,
    impressionRate: 38,
    reachRate: 32,
    baseEfficiency: 80
  },
  {
    id: 'pinterest_promoted',
    name: 'Pinterest Promoted Pins',
    minBudget: 10000,
    maxBudget: 80000,
    impressionRate: 32,
    reachRate: 28,
    baseEfficiency: 78
  },
  {
    id: 'linkedin_feed',
    name: 'LinkedIn Feed Ads',
    minBudget: 20000,
    maxBudget: 120000,
    impressionRate: 30,
    reachRate: 25,
    baseEfficiency: 75,
    isDeal: true
  },
  {
    id: 'twitter_timeline',
    name: 'Twitter Timeline',
    minBudget: 15000,
    maxBudget: 90000,
    impressionRate: 35,
    reachRate: 30,
    baseEfficiency: 77
  },
  {
    id: 'youtube_shorts',
    name: 'YouTube Shorts',
    minBudget: 25000,
    maxBudget: 180000,
    impressionRate: 42,
    reachRate: 36,
    baseEfficiency: 85
  },
  {
    id: 'reddit_feed',
    name: 'Reddit Feed Ads',
    minBudget: 12000,
    maxBudget: 85000,
    impressionRate: 33,
    reachRate: 28,
    baseEfficiency: 76
  },
  {
    id: 'twitch_stream',
    name: 'Twitch Stream Ads',
    minBudget: 18000,
    maxBudget: 110000,
    impressionRate: 36,
    reachRate: 31,
    baseEfficiency: 79,
    isDeal: true
  },
  {
    id: 'instagram_shop',
    name: 'Instagram Shop Ads',
    minBudget: 15000,
    maxBudget: 95000,
    impressionRate: 37,
    reachRate: 32,
    baseEfficiency: 81
  },
  {
    id: 'snap_spotlight',
    name: 'Snapchat Spotlight',
    minBudget: 20000,
    maxBudget: 130000,
    impressionRate: 41,
    reachRate: 35,
    baseEfficiency: 83
  },
  {
    id: 'tiktok_spark',
    name: 'TikTok Spark Ads',
    minBudget: 22000,
    maxBudget: 160000,
    impressionRate: 44,
    reachRate: 37,
    baseEfficiency: 86
  },
  {
    id: 'meta_reels',
    name: 'Meta Reels Ads',
    minBudget: 18000,
    maxBudget: 140000,
    impressionRate: 43,
    reachRate: 36,
    baseEfficiency: 84,
    isDeal: true
  }
]; 